<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <h1 class="my-3">Редактирование торговой точки</h1>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Фактический адрес"
              v-model="factAddress"
              :rules="textInputRules"
              validate-on-blur
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Телефон"
              v-model="phone"
              mask="+7 (###) ###-##-##"
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="ИНН"
              v-model="inn"
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Юридическое лицо"
              v-model="legalTitle"
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Юридический адрес"
              v-model="legalAddress"
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <p class="title" v-if="pointTypeList.length > 0">Тип торговой точки</p>
      <v-layout
          row
          v-if="pointTypeList.length > 0"
          class="mb-4"
      >
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1">
          <v-radio-group v-model="pointTypeId">
            <v-radio
                v-for="(pointType, index) in pointTypeList"
                :key="index"
                :label="pointType.title"
                :value="pointType.id"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <p class="title" v-if="pointTreeData.length > 0">Папка торговой точки</p>
      <v-layout
          row
          v-if="pointTreeData.length > 0"
          class="mb-4"
      >
        <v-flex xs12 lg8 md8 px-3 class="elevation-1 white">
          <div v-if="pointTreeData.length > 0">
            <v-radio-group v-model="pointFolderId">
              <tree
                  :data="pointTreeData"
                  :options="{
                  fetchData(node) {
                    if (node.children.length > 0) {
                      return blank()
                    } else {
                      return getPointFolder(node.data.id)
                    }
                  }
                }"
                  class="tree--small"
              >
                <span class="tree-text body-2 ma-0 py-1 px-0" slot-scope="{ node }">
                  <template v-if="node.data.type === 'folder'">
                    <v-radio
                        class="ma-0 pa-0"
                        :label="node.data.text"
                        :value="node.data.id"
                    ></v-radio>
                  </template>
                </span>
              </tree>
            </v-radio-group>
          </div>
        </v-flex>
      </v-layout>

      <p class="title">Канал продаж</p>
      <v-layout
          row
          v-if="channelList.length > 0"
          class="mb-4"
      >
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <v-radio-group v-model="distributionChannelId">
            <v-radio
                v-for="(channel, index) in channelList"
                :key="index"
                :label="channel.title"
                :value="channel.id"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <p class="title">Период отсрочки</p>
      <v-layout
          row
          v-if="maxDebtPeriodList.length > 0"
          class="mb-4"
      >
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <v-radio-group v-model="maxDebtPeriod">
            <v-radio
                v-for="(period, index) in maxDebtPeriodList"
                :key="index"
                :label="period.title"
                :value="period.value"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <p class="title">Директор</p>
          <v-card class="mx-0 mt-0 mb-4 elevation-1">
            <v-layout>
              <v-flex xs10 lg10 md10 class="ml-4 mt-4">
                <v-text-field
                    label="Имя"
                    v-model="owner.firstName"
                    outline
                ></v-text-field>
                <v-text-field
                    label="Фамилия"
                    v-model="owner.surname"
                    outline
                ></v-text-field>
                <v-text-field
                    label="Отчество"
                    v-model="owner.patronymic"
                    outline
                ></v-text-field>
                <v-menu
                    ref="ownerMenu"
                    :close-on-content-click="false"
                    v-model="ownerMenu"
                    :nudge-right="40"
                    :return-value.sync="ownerDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <v-text-field
                      slot="activator"
                      v-model="owner.birthDate"
                      label="Дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="ownerDate"
                      @input="$refs.ownerMenu.save(ownerDate)"
                      locale="ru"
                      :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                    label="Телефон"
                    v-model="owner.phone"
                    mask="+7 (###) ###-##-##"
                    outline
                ></v-text-field>
                <v-text-field
                    label="Email"
                    v-model="owner.email"
                    outline
                ></v-text-field>

                <p class="subheading font-weight-bold">Паспорт:</p>

                <v-text-field
                    label="Серия и номер"
                    v-model="owner.passport.serialNumber"
                    outline
                ></v-text-field>
                <v-text-field
                    label="Кем выдан"
                    v-model="owner.passport.issuingAuthority"
                    outline
                ></v-text-field>
                <v-menu
                    ref="ownerPassportMenu"
                    :close-on-content-click="false"
                    v-model="ownerPassportMenu"
                    :nudge-right="40"
                    :return-value.sync="ownerPassportDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <v-text-field
                      slot="activator"
                      v-model="owner.passport.issueDate"
                      label="Дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="ownerPassportDate"
                      @input="$refs.ownerPassportMenu.save(ownerPassportDate)"
                      locale="ru"
                      :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                    label="Код подразделения"
                    v-model="owner.passport.unitCode"
                    outline
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <p class="title">Ответственный</p>
          <v-card class="mx-0 mt-0 mb-4 elevation-1">
            <v-layout>
              <v-flex xs10 lg10 md10 class="ml-4 mt-2">
                <v-radio-group v-model="responsible.isOwner">
                  <v-radio
                      label="является директором"
                      :value="1"
                  ></v-radio>
                  <v-radio
                      label="новые данные"
                      :value="0"
                  ></v-radio>
                </v-radio-group>
                <div v-if="responsible.isOwner !== 1">
                  <v-text-field
                      label="Имя"
                      v-model="responsible.firstName"
                      outline
                  ></v-text-field>
                  <v-text-field
                      label="Фамилия"
                      v-model="responsible.surname"
                      outline
                  ></v-text-field>
                  <v-text-field
                      label="Отчество"
                      v-model="responsible.patronymic"
                      outline
                  ></v-text-field>
                  <v-menu
                      ref="responsibleMenu"
                      :close-on-content-click="false"
                      v-model="responsibleMenu"
                      :nudge-right="40"
                      :return-value.sync="responsibleDate"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        v-model="responsible.birthDate"
                        label="Дата"
                        readonly
                        outline
                    ></v-text-field>
                    <v-date-picker
                        v-model="responsibleDate"
                        @input="$refs.responsibleMenu.save(responsibleDate)"
                        locale="ru"
                        :first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                  <v-text-field
                      label="Телефон"
                      v-model="responsible.phone"
                      mask="+7 (###) ###-##-##"
                      outline
                  ></v-text-field>
                  <v-text-field
                      label="Email"
                      v-model="responsible.email"
                      outline
                  ></v-text-field>

                  <p class="subheading font-weight-bold">Паспорт:</p>

                  <v-text-field
                      label="Серия и номер"
                      v-model="responsible.passport.serialNumber"
                      outline
                  ></v-text-field>
                  <v-text-field
                      label="Кем выдан"
                      v-model="responsible.passport.issuingAuthority"
                      outline
                  ></v-text-field>
                  <v-menu
                      ref="responsiblePassportMenu"
                      :close-on-content-click="false"
                      v-model="responsiblePassportMenu"
                      :nudge-right="40"
                      :return-value.sync="responsiblePassportDate"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        v-model="responsible.passport.issueDate"
                        label="Дата"
                        readonly
                        outline
                    ></v-text-field>
                    <v-date-picker
                        v-model="responsiblePassportDate"
                        @input="$refs.responsiblePassportMenu.save(responsiblePassportDate)"
                        locale="ru"
                        :first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                  <v-text-field
                      label="Код подразделения"
                      v-model="responsible.passport.unitCode"
                      outline
                  ></v-text-field>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6 v-if="pointStatus !== null ? pointStatus.id === 1 : false">
          <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickEditPoint"
          >
            Продолжить
          </v-btn>
          <v-btn
              color="error"
              class="ma-0"
              @click="cancelDialog = true"
          >
            Отклонить
          </v-btn>
        </v-flex>
        <v-flex xs12 lg6 md6 v-if="pointStatus !== null ? pointStatus.id === 2 || pointStatus.id === 3 : false">
          <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickEditPoint"
          >
            Изменить
          </v-btn>
        </v-flex>
      </v-layout>

      <v-dialog
          v-model="cancelDialog"
          max-width="300"
      >
        <v-card>
          <v-card-title class="headline">Отклонить заявку?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="error"
                @click="cancelPointConfirm()"
            >
              Да
            </v-btn>

            <v-btn
                @click="cancelPointOnCancel()"
            >
              Нет
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Заявки', link: '/points/request/security/list'},
        {name: 'Редактирование торговой точки'}
      ],
      pageDataReady: {
        isReady: false,
        distributionChannelList: false,
        point: false,
        pointTypeList: false,
        points: false
      },
      map: null,
      id: null,
      channelList: [],
      maxDebtPeriodList: [
        {value: 0, title: 'по факту'},
        {value: 7, title: 'неделя'},
        {value: 14, title: 'две недели'}
      ],
      factAddress: null,
      coordinate: null,
      phone: null,
      marginPercent: null,
      pointTypeId: null,
      pointTreeData: [],
      pointIdCounter: 0,
      pointLoading: false,
      distributionChannelId: null,
      inn: null,
      legalTitle: null,
      legalAddress: null,
      maxDebtPeriod: null,
      pointStatus: null,
      photoList: [],
      cargoPhotoList: [],
      showcasePhotoList: [],

      owner: {
        firstName: null,
        surname: null,
        patronymic: null,
        birthDate: null,
        phone: null,
        email: null,
        passport: {
          serialNumber: null,
          issuingAuthority: null,
          issueDate: null,
          unitCode: null,
          photoIdList: []
        }
      },
      ownerDate: null,
      ownerMenu: null,
      ownerPassportDate: null,
      ownerPassportMenu: null,

      responsible: {
        isOwner: 1,
        firstName: null,
        surname: null,
        patronymic: null,
        birthDate: null,
        phone: null,
        email: null,
        passport: {
          serialNumber: null,
          issuingAuthority: null,
          issueDate: null,
          unitCode: null,
          photoIdList: []
        }
      },
      responsibleDate: null,
      responsibleMenu: null,
      responsiblePassportDate: null,
      responsiblePassportMenu: null,

      cancelDialog: false,
      cancelPointId: null,

      valid: false,
      textInputRules: [
        v => !!v || 'Обязательное поле'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.distributionChannelList) {
          return false
        }
        if (!this.pageDataReady.point) {
          return false
        }
        if (!this.pageDataReady.pointTypeList) {
          return false
        }
        if (!this.pageDataReady.points) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      initMap (instance) {
        this.map = instance
        this.map.behaviors.disable('scrollZoom')
        this.mapZoomUpdate()
      },
      mapZoomUpdate () {
        if (this.map !== null && this.map.geoObjects.getBounds() !== null) {
          this.map.setBounds(this.map.geoObjects.getBounds())
          if (this.map.getZoom() > 18) {
            this.map.setZoom(18)
          }
        }
      },
      checkValidate () {
        this.valid = true
        return this.valid
      },
      cancelPointOnCancel () {
        this.cancelDialog = false
        this.cancelPointId = null
      },
      async cancelPointConfirm () {
        await this.$store.dispatch('securityDeclinePoint', {id: this.id})
          .then((data) => {
            this.$router.push('/points/request/security/list')
          })
          .catch((e) => {
            console.log(e)
          })
      },
      async onClickEditPoint () {
        let data = {
          id: this.id,
          fact_address: this.factAddress,
          phone: this.phone,
          margin_percent: this.marginPercent,
          point_type_id: this.pointTypeId,
          point_folder_id: this.pointFolderId,
          distribution_channel_id: this.distributionChannelId,
          inn: this.inn,
          legal_title: this.legalTitle,
          legal_address: this.legalAddress,
          max_debt_period: this.maxDebtPeriod,
          owner_person: {
            first_name: this.owner.firstName,
            surname: this.owner.surname,
            patronymic: this.owner.patronymic,
            birth_date: this.owner.birthDate,
            phone: this.owner.phone,
            email: this.owner.email,
            passport: {
              serial_number: this.owner.passport.serialNumber,
              issuing_authority: this.owner.passport.issuingAuthority,
              issue_date: this.owner.passport.issueDate,
              unit_code: this.owner.passport.unitCode
            }
          },
          responsible_person: {
            is_owner: this.responsible.isOwner
          }
        }
        if (this.responsible.isOwner === 0) {
          data.responsible_person.first_name = this.responsible.firstName
          data.responsible_person.surname = this.responsible.surname
          data.responsible_person.patronymic = this.responsible.patronymic
          data.responsible_person.phone = this.responsible.phone
          data.responsible_person.email = this.responsible.email
          data.responsible_person.passport = {
            serial_number: this.responsible.passport.serialNumber,
            issuing_authority: this.responsible.passport.issuingAuthority,
            issue_date: this.responsible.passport.issueDate,
            unit_code: this.responsible.passport.unitCode
          }
        }

        await this.$store.dispatch('securityUpdatePoint', data)
          .then((data) => {
            if (typeof data.point !== 'undefined') {
              this.$router.push('/points/single/' + this.id)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)
        this.map = null
        this.id = null
        this.factAddress = null
        this.phone = '+7'
        this.marginPercent = null
        this.pointTypeId = null
        this.pointFolderId = null
        this.distributionChannelId = null
        this.inn = null
        this.legalTitle = null
        this.legalAddress = null
        this.maxDebtPeriod = null
        this.coordinate = null
        this.pointStatus = null
        this.photoList = []
        this.cargoPhotoList = []
        this.showcasePhotoList = []

        this.owner = {
          firstName: null,
          surname: null,
          patronymic: null,
          birthDate: null,
          phone: '+7',
          email: null,
          passport: {
            serialNumber: null,
            issuingAuthority: null,
            issueDate: null,
            unitCode: null,
            photoIdList: []
          }
        }

        this.ownerDate = null
        this.ownerMenu = null
        this.ownerPassportDate = null
        this.ownerPassportMenu = null

        this.responsible = {
          isOwner: 1,
          firstName: null,
          surname: null,
          patronymic: null,
          birthDate: null,
          phone: '+7',
          email: null,
          passport: {
            serialNumber: null,
            issuingAuthority: null,
            issueDate: null,
            unitCode: null,
            photoIdList: []
          }
        }

        this.responsibleDate = null
        this.responsibleMenu = null
        this.responsiblePassportDate = null
        this.responsiblePassportMenu = null

        this.pointTreeData = []
        this.pointIdCounter = 0
        this.pointLoading = false

        if (~this.$router.currentRoute.path.indexOf('/points/security/edit/')) {
          this.id = parseInt(this.$route.params.id)
        }

        this.$store.commit('setPageTitle', 'Редактирование торговой точки')

        this.$store.dispatch('getDistributionChannelList')
          .then(() => {
            this.pageDataReady.distributionChannelList = true
            this.pageDataStatus()
          })
        this.$store.dispatch('getPointSingle', {id: this.id})
          .then(() => {
            this.pageDataReady.point = true
            this.pageDataStatus()
          })
        this.$store.dispatch('getPointTypeList')
          .then(() => {
            this.pageDataReady.pointTypeList = true
            this.pageDataStatus()
          })
      },
      async getPointFolder (nodeId) {
        let folder = []
        await this.$store.dispatch('getPointFolderList', {id: nodeId, mode: this.mode})
          .then((data) => {
            for (let i = 0; i < data.point_folder_list.length; i++) {
              folder.push({
                text: data.point_folder_list[i].title,
                data: {
                  id: data.point_folder_list[i].id,
                  type: 'folder',
                  children: []
                },
                id: this.pointIdCounter++,
                isBatch: data.point_folder_list[i].have_children
              })
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return folder
      },
      async pointTreeLoader (id = 0) {
        this.pointLoading = true
        let pointTreeData = await this.$store.dispatch('getPointFolderList', {id: id, mode: 'active'})
          .then((data) => {
            return data
          })
          .catch((e) => {
            console.log(e)
          })

        if (typeof pointTreeData.point_folder_list !== 'undefined') {
          for (let i = 0; i < pointTreeData.point_folder_list.length; i++) {
            if (this.isChildrenInPointTree(pointTreeData.point_folder_list[i].id, this.pointSingle.point_folder_tree)) {
              let child = await this.pointTreeLoader(pointTreeData.point_folder_list[i].id)
              pointTreeData.point_folder_list[i].point_folder_list = child.point_folder_list
            }
          }
        }

        if (id === 0) {
          this.pointTreeData = this.pointTreeDataStructure([pointTreeData], this.pointSingle.point_folder_tree)[0].children
          this.pointLoading = false
          this.pageDataReady.points = true
          this.pageDataStatus()
        } else {
          return pointTreeData
        }
      },
      pointTreeDataStructure (pointFolderList, tree = null) {
        let resultList = []

        for (let i = 0; i < pointFolderList.length; i++) {
          resultList[i] = {
            text: pointFolderList[i].title,
            data: {
              id: pointFolderList[i].id,
              type: 'folder'
            },
            id: this.pointTreeIdCounter++,
            isBatch: pointFolderList[i].have_children,
            state: {}
          }

          if (tree !== null) {
            resultList[i].state.expanded = this.isChildrenInPointTree(pointFolderList[i].id, tree)
          }

          if (typeof pointFolderList[i].point_folder_list !== 'undefined') {
            resultList[i].children = []
            resultList[i].children = this.pointTreeDataStructure(pointFolderList[i].point_folder_list, tree)
          }
        }
        return resultList
      },
      isChildrenInPointTree (id, tree) {
        if (tree !== null && typeof tree !== 'undefined') {
          for (let i = 0; i < tree.length; i++) {
            let isId = tree[i].id === id
            let isFolders = typeof tree[i].point_folder_list !== 'undefined' ? tree[i].point_folder_list.length > 0 : false

            if (isId && isFolders) {
              return true
            } else if (isFolders) {
              if (this.isChildrenInPointTree(id, tree[i].point_folder_list)) {
                return true
              }
            }
          }
        }
        return false
      },
      async blank () {
        return []
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      pointSingle () {
        return this.$store.getters.pointSingle
      },
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      pointTypeList () {
        return this.$store.getters.pointTypeList
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      distributionChannelList (n, o) {
        this.channelList = this.distributionChannelList

        for (let i = 0; i < this.channelList.length; i++) {
          if (this.channelList[i].id === this.distributionChannelId) {
            this.channelList[i].checked = true
          } else {
            this.channelList[i].checked = false
          }
        }
      },
      pointSingle (val) {
        if (this.pointSingle !== null) {
          this.factAddress = this.pointSingle.fact_address !== null ? this.pointSingle.fact_address : null
          this.phone = this.pointSingle.phone !== null ? this.pointSingle.phone : null
          this.marginPercent = this.pointSingle.margin_percent !== null ? this.pointSingle.margin_percent : null
          this.pointTypeId = this.pointSingle.point_type !== null ? this.pointSingle.point_type.id : null
          this.pointFolderId = this.pointSingle.point_folder_id !== null ? this.pointSingle.point_folder_id : null
          this.distributionChannelId = this.pointSingle.distribution_channel !== null ? this.pointSingle.distribution_channel.id : null
          this.inn = this.pointSingle.inn !== null ? this.pointSingle.inn : null
          this.legalTitle = this.pointSingle.legal_title !== null ? this.pointSingle.legal_title : null
          this.legalAddress = this.pointSingle.legal_address !== null ? this.pointSingle.legal_address : null
          this.maxDebtPeriod = this.pointSingle.max_debt_period !== null ? this.pointSingle.max_debt_period : null
          this.pointStatus = this.pointSingle.point_status !== null ? this.pointSingle.point_status : null
          if (this.pointSingle.coordinate !== null) {
            this.coordinate = [this.pointSingle.coordinate.lat, this.pointSingle.coordinate.lng]
          }
          this.owner = {
            firstName: this.pointSingle.owner_person !== null ? this.pointSingle.owner_person.first_name : null,
            surname: this.pointSingle.owner_person !== null ? this.pointSingle.owner_person.surname : null,
            patronymic: this.pointSingle.owner_person !== null ? this.pointSingle.owner_person.patronymic : null,
            birthDate: this.pointSingle.owner_person !== null ? this.formatDate(this.pointSingle.owner_person.birth_date) : null,
            phone: this.pointSingle.owner_person !== null ? this.pointSingle.owner_person.phone : null,
            email: this.pointSingle.owner_person !== null ? this.pointSingle.owner_person.email : null
          }
          this.ownerDate = this.pointSingle.owner_person !== null ? this.pointSingle.owner_person.birth_date : null

          if (this.pointSingle.owner_person !== null ? this.pointSingle.owner_person.passport !== null : false) {
            this.owner.passport = {
              serialNumber: this.pointSingle.owner_person.passport.serial_number,
              issuingAuthority: this.pointSingle.owner_person.passport.issuing_authority,
              issueDate: this.formatDate(this.pointSingle.owner_person.passport.issue_date),
              unitCode: this.pointSingle.owner_person.passport.unit_code,
              photoIdList: []
            }
            this.ownerPassportDate = this.pointSingle.owner_person.passport.issue_date
          } else {
            this.owner.passport = {
              serialNumber: null,
              issuingAuthority: null,
              issueDate: null,
              unitCode: null,
              photoIdList: []
            }
          }

          if (this.pointSingle.responsible_person !== null) {
            if (this.pointSingle.responsible_person.is_owner) {
              this.responsible.isOwner = 1
            } else {
              this.responsible = {
                isOwner: 0,
                firstName: this.pointSingle.responsible_person.first_name,
                surname: this.pointSingle.responsible_person.surname,
                patronymic: this.pointSingle.responsible_person.patronymic,
                birthDate: this.formatDate(this.pointSingle.responsible_person.birth_date),
                phone: this.pointSingle.responsible_person.phone,
                email: this.pointSingle.responsible_person.email
              }
              this.responsibleDate = this.pointSingle.responsible_person.birth_date

              if (this.pointSingle.responsible_person.passport !== null) {
                this.responsible.passport = {
                  serialNumber: this.pointSingle.responsible_person.passport.serial_number,
                  issuingAuthority: this.pointSingle.responsible_person.passport.issuing_authority,
                  issueDate: this.formatDate(this.pointSingle.responsible_person.passport.issue_date),
                  unitCode: this.pointSingle.responsible_person.passport.unit_code,
                  photoIdList: []
                }
                this.responsiblePassportDate = this.pointSingle.responsible_person.passport.issue_date
              } else {
                this.responsible.passport = {
                  serialNumber: null,
                  issuingAuthority: null,
                  issueDate: null,
                  unitCode: null,
                  photoIdList: []
                }
              }
            }
          }

          if (typeof this.pointSingle.point_folder_tree !== 'undefined') {
            this.pointTreeLoader()
          } else {
            this.getPointFolder(0)
              .then((data) => {
                this.pointTreeData = data
                this.pageDataReady.points = true
                this.pageDataStatus()
              })
              .catch(() => {})
          }
        }
      },
      ownerDate (val) {
        this.owner.birthDate = this.formatDate(this.ownerDate)
      },
      ownerPassportDate (val) {
        this.owner.passport.issueDate = this.formatDate(this.ownerPassportDate)
      },
      responsibleDate (val) {
        this.responsible.birthDate = this.formatDate(this.responsibleDate)
      },
      responsiblePassportDate (val) {
        this.responsible.passport.issueDate = this.formatDate(this.responsiblePassportDate)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Points/PointSecurityEdit.vue